// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__I9hm5","ranges":"BmiRanges_ranges__JhfJe"};